import React, { useState } from 'react';
import { BsClipboardCheck } from 'react-icons/bs';


export default function CaracteristicasProduto({
  produto,
  imagemProduto,
  modulos = [],
  isMobile,
  isTablet,
  windowDimensions,
  onOrcamento
}) {

  // =========================================================
  // ESTADO DO ACCORDION
  // IMPORTANTE: hook fica antes de qualquer return condicional
  // =========================================================

  const [detalheAberto, setDetalheAberto] = useState(null);


  if (!produto) return null;


  // =========================================================
  // ACEITA API RETORNANDO OBJETO OU ARRAY
  // =========================================================

  const p = Array.isArray(produto)
    ? produto[0] || {}
    : produto;


  // =========================================================
  // RESPONSIVIDADE
  // =========================================================

  const width =
    windowDimensions?.width ||
    (
      typeof window !== 'undefined'
        ? window.innerWidth
        : 1200
    );


  const mobile =
    typeof isMobile === 'boolean'
      ? isMobile
      : width <= 768;


  const tablet =
    typeof isTablet === 'boolean'
      ? isTablet
      : width > 768 && width < 1180;


  // =========================================================
  // LÊ AUTOMATICAMENTE:
  //
  // titulo_estrutura -> valor_estrutura
  // titulo_assento   -> valor_assento
  // titulo_encosto   -> valor_encosto
  //
  // Qualquer novo titulo_x + valor_x entra automaticamente.
  // =========================================================

  const pairs = [];


  Object.keys(p).forEach((key) => {

    if (!key.startsWith('titulo_')) return;


    const suffix =
      key.replace(/^titulo_/, '');


    const title =
      p[key] !== null &&
        p[key] !== undefined
        ? String(p[key]).trim()
        : '';


    if (!title) return;


    const valueKey =
      `valor_${suffix}`;


    let value =
      p[valueKey];


    if (
      value === null ||
      value === undefined
    ) {
      value = '';
    }


    value =
      String(value).trim();


    pairs.push({
      id: suffix,
      title,
      value
    });

  });


  // =========================================================
  // ORDEM VISUAL PREFERIDA
  // =========================================================

  const ordemPreferida = [
    'estrutura',
    'madeira',
    'assento',
    'encosto',
    'almofadas',
    'bracos',
    'braco',
    'embalagem',
    'grampos',
    'modulo_puff'
  ];


  pairs.sort((a, b) => {

    const indexA =
      ordemPreferida.indexOf(a.id);

    const indexB =
      ordemPreferida.indexOf(b.id);


    if (
      indexA === -1 &&
      indexB === -1
    ) {
      return 0;
    }


    if (indexA === -1) {
      return 1;
    }


    if (indexB === -1) {
      return -1;
    }


    return indexA - indexB;

  });


  // =========================================================
  // SEPARA MÓDULOS DOS CARDS PRINCIPAIS
  // =========================================================

  const paresModulos =
    pairs.filter((item) =>
      item.id.startsWith('opcoes_modulos_')
    );


  const detalhes =
    pairs.filter((item) =>
      !item.id.startsWith('opcoes_modulos_')
    );


  // =========================================================
  // CAMPOS SIMPLES DO COMPONENTE ANTIGO
  // =========================================================

  const camposSimples = [
    {
      key: 'marca',
      label: 'Marca'
    },
    {
      key: 'modelo',
      label: 'Modelo'
    },
    {
      key: 'altura',
      label: 'Altura'
    },
    {
      key: 'largura',
      label: 'Largura'
    },
    {
      key: 'comprimento',
      label: 'Comprimento'
    },
    {
      key: 'profundidade',
      label: 'Profundidade'
    }
  ];


  camposSimples.forEach(
    ({ key, label }) => {

      const value =
        p[key];


      if (
        value === undefined ||
        value === null ||
        String(value).trim() === ''
      ) {
        return;
      }


      const jaExiste =
        detalhes.some(
          (item) =>
            item.id === key ||
            item.title
              .toLowerCase()
              .trim() ===
            label
              .toLowerCase()
              .trim()
        );


      if (!jaExiste) {

        detalhes.push({
          id: key,
          title: label,
          value: String(value).trim(),
          simple: true
        });

      }

    }
  );


  // =========================================================
  // CONTEÚDO EXTRA DA BANDEJA
  //
  // Futuramente você pode escolher UM padrão no banco.
  // Exemplo recomendado:
  //
  // beneficio_assento
  // beneficio_encosto
  // beneficio_estrutura
  //
  // Mas deixei compatibilidade com outros nomes.
  // =========================================================

  const getInfoDetalhe = (item) => {

    const id =
      item.id;


    const candidatos = [
      p[`beneficio_${id}`],
      p[`beneficios_${id}`],
      p[`info_${id}`],
      p[`informacao_${id}`],
      p[`motivo_${id}`],
      p[`motivos_${id}`],
      p[`descricao_extra_${id}`]
    ];


    // aliases para estrutura/madeira

    if (id === 'estrutura') {

      candidatos.push(
        p.beneficio_madeira,
        p.beneficios_madeira,
        p.info_madeira,
        p.informacao_madeira,
        p.motivo_madeira,
        p.motivos_madeira
      );

    }


    // aliases para braços

    if (id === 'bracos') {

      candidatos.push(
        p.beneficio_braco,
        p.beneficios_braco,
        p.info_braco,
        p.informacao_braco,
        p.motivo_braco,
        p.motivos_braco
      );

    }


    if (id === 'braco') {

      candidatos.push(
        p.beneficio_bracos,
        p.beneficios_bracos,
        p.info_bracos,
        p.informacao_bracos,
        p.motivo_bracos,
        p.motivos_bracos
      );

    }


    const encontrada =
      candidatos.find(
        (valor) =>
          valor !== undefined &&
          valor !== null &&
          String(valor).trim() !== ''
      );


    return encontrada
      ? String(encontrada).trim()
      : '';

  };


  // =========================================================
  // IMAGEM AUTOMÁTICA DO DETALHE
  //
  // Exemplos futuros:
  //
  // imagem_assento
  // imagem_encosto
  // imagem_estrutura
  // imagem_bracos
  // =========================================================

  const getImagemDetalhe = (item) => {

    const id =
      item.id;


    const candidatos = [
      p[`imagem_${id}`],
      p[`imagem_${id}_url`],
      p[`url_imagem_${id}`]
    ];


    if (id === 'estrutura') {

      candidatos.push(
        p.imagem_madeira,
        p.imagem_madeira_url
      );

    }


    if (id === 'bracos') {

      candidatos.push(
        p.imagem_braco,
        p.imagem_braco_url
      );

    }


    if (id === 'braco') {

      candidatos.push(
        p.imagem_bracos,
        p.imagem_bracos_url
      );

    }


    const encontrada =
      candidatos.find(
        (imagem) =>
          imagem !== undefined &&
          imagem !== null &&
          String(imagem).trim() !== ''
      );


    return encontrada || '';

  };


  // =========================================================
  // NOME E DESCRIÇÃO
  // =========================================================

  const nomeProduto =
    p.produto_nome || '';


  const descricaoProduto =
    p.produto_descricao || '';


  // =========================================================
  // IMAGEM PRINCIPAL
  // =========================================================

  const imagemPrincipal =
    imagemProduto ||
    p.imagem_principal ||
    p.imagem_url ||
    (
      Array.isArray(p.imagem_urls)
        ? p.imagem_urls[0]
        : ''
    ) ||
    '';


  // =========================================================
  // IMAGEM DAS DIMENSÕES
  // =========================================================

  const imagemDimensoes =
    p.imagem_dimensoes ||
    p.dimensoes_imagem ||
    p.imagem_medidas ||
    p.imagem_tecnica ||
    '';


  // =========================================================
  // MEDIDAS
  // =========================================================

  const medidas = [
    {
      label: 'Altura',
      value: p.altura
    },
    {
      label: 'Largura',
      value: p.largura
    },
    {
      label: 'Comprimento',
      value: p.comprimento
    },
    {
      label: 'Profundidade',
      value: p.profundidade
    }
  ].filter(
    (item) =>
      item.value !== undefined &&
      item.value !== null &&
      String(item.value).trim() !== ''
  );


  // =========================================================
  // MÓDULOS
  // =========================================================

  const modulosEncontrados = [];


  if (Array.isArray(modulos)) {

    modulos.forEach((valor) => {

      if (
        valor !== null &&
        valor !== undefined &&
        String(valor).trim() !== ''
      ) {

        modulosEncontrados.push(
          String(valor).trim()
        );

      }

    });

  }


  paresModulos.forEach((item) => {

    let valor =
      item.value;


    if (!valor) {

      valor =
        item.id.replace(
          'opcoes_modulos_',
          ''
        );

    }


    if (
      valor !== null &&
      valor !== undefined &&
      String(valor).trim() !== ''
    ) {

      modulosEncontrados.push(
        String(valor).trim()
      );

    }

  });


  const modulosUnicos =
    [...new Set(modulosEncontrados)];


  // =========================================================
  // FORMATA O TEXTO DO MÓDULO
  // =========================================================

  const formatModulo = (valor) => {

    const texto =
      String(valor).trim();


    if (!texto) {
      return '';
    }


    if (/cm/i.test(texto)) {
      return texto;
    }


    if (
      /^[0-9]+([.,][0-9]+)?$/.test(texto)
    ) {
      return `${texto} cm`;
    }


    return texto;

  };


  // =========================================================
  // IMAGEM DO CARD
  // =========================================================

  const renderImagemDetalhe = (item) => {

    const imagem =
      getImagemDetalhe(item);


    return (

      <div
        style={{
          width: mobile ? 64 : 84,
          height: mobile ? 64 : 82,
          borderRadius: 8,
          overflow: 'hidden',
          background: '#f2efeb',
          border: '1px solid #eee8e1',
          boxSizing: 'border-box',
          flex: '0 0 auto'
        }}
      >

        {imagem ? (

          <img
            src={imagem}
            alt={item.title}
            style={{
              display: 'block',
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />

        ) : (

          <div
            style={{
              width: '100%',
              height: '100%',
              background:
                'linear-gradient(135deg, #eeeae5 0%, #f8f6f3 100%)'
            }}
          />

        )}

      </div>

    );

  };


  // =========================================================
  // RENDER
  // =========================================================

  return (

    <section
      translate="no"
      style={{
        width: '100%',
        marginTop: mobile ? 32 : 54,
        boxSizing: 'border-box'
      }}
    >


      {/* =====================================================
          TÍTULO
      ===================================================== */}

      <div
        style={{
          fontSize: mobile ? 9 : 11,
          letterSpacing: '0.30em',
          textTransform: 'uppercase',
          color: '#a79e96',
          marginBottom: mobile ? 18 : 24
        }}
      >
        DETALHES DO PRODUTO
      </div>


      {/* =====================================================
          GRID PRINCIPAL
      ===================================================== */}

      <div
        style={{
          display: 'grid',

          gridTemplateColumns:
            mobile
              ? '1fr'
              : tablet
                ? 'minmax(0, 1fr) minmax(0, 0.95fr)'
                : 'minmax(0, 1.08fr) minmax(0, 0.92fr)',

          gap: mobile ? 28 : 42,

          alignItems: 'start',

          width: '100%',

          boxSizing: 'border-box'
        }}
      >


        {/* ===================================================
            COLUNA ESQUERDA
        =================================================== */}

        <div
          style={{
            minWidth: 0
          }}
        >


          {/* NOME */}

          {nomeProduto && (

            <h2
              style={{
                margin: 0,

                fontFamily:
                  'Georgia, Times New Roman, serif',

                fontSize:
                  mobile
                    ? 33
                    : tablet
                      ? 39
                      : 47,

                lineHeight: 1.05,

                fontWeight: 400,

                letterSpacing: '-0.035em',

                color: '#251f1a'
              }}
            >
              {nomeProduto}
            </h2>

          )}


          {/* LINHA DOURADA */}

          <div
            style={{
              width: mobile ? 82 : 118,
              height: 3,
              background: '#d6aa2c',
              marginTop: 18,
              marginBottom: 20
            }}
          />


          {/* DESCRIÇÃO */}

          {descricaoProduto && (

            <p
              style={{
                margin: '0 0 28px',
                maxWidth: 690,
                fontSize: mobile ? 13 : 15,
                lineHeight: 1.58,
                color: '#716962'
              }}
            >
              {descricaoProduto}
            </p>

          )}


          {/* =================================================
              CARDS / ACCORDION
          ================================================= */}

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 10
            }}
          >

            {detalhes.map((item) => {

              const aberto =
                detalheAberto === item.id;


              const infoExtra =
                getInfoDetalhe(item);


              return (

                <div
                  key={item.id}
                  style={{
                    width: '100%'
                  }}
                >


                  {/* ===========================================
                      CARD CLICÁVEL
                  =========================================== */}

                  <div
                    onClick={() => {
                      setDetalheAberto(
                        aberto
                          ? null
                          : item.id
                      );
                    }}

                    role="button"

                    tabIndex={0}

                    aria-expanded={aberto}

                    onKeyDown={(e) => {

                      if (
                        e.key === 'Enter' ||
                        e.key === ' '
                      ) {

                        e.preventDefault();

                        setDetalheAberto(
                          aberto
                            ? null
                            : item.id
                        );

                      }

                    }}

                    style={{
                      width: '100%',

                      minHeight:
                        mobile
                          ? 88
                          : 105,

                      display: 'grid',

                      gridTemplateColumns:
                        mobile
                          ? '64px minmax(0,1fr) 24px'
                          : '84px minmax(0,1fr) 28px',

                      gap:
                        mobile
                          ? 12
                          : 17,

                      alignItems: 'center',

                      boxSizing: 'border-box',

                      padding:
                        mobile
                          ? '10px'
                          : '12px 15px',

                      background:
                        aberto
                          ? '#fdfcfb'
                          : '#fff',

                      border:
                        aberto
                          ? '1px solid #cbbfb5'
                          : '1px solid #e6e0d9',

                      borderRadius:
                        aberto
                          ? '9px 9px 0 0'
                          : 9,

                      cursor: 'pointer',

                      transition:
                        'border-color 180ms ease, background 180ms ease'
                    }}
                  >


                    {/* IMAGEM */}

                    {renderImagemDetalhe(item)}


                    {/* TEXTO */}

                    <div
                      style={{
                        minWidth: 0
                      }}
                    >

                      <div
                        style={{
                          fontSize:
                            mobile
                              ? 10
                              : 11,

                          fontWeight: 600,

                          letterSpacing: '0.28em',

                          textTransform: 'uppercase',

                          color: '#30261f',

                          marginBottom: 7
                        }}
                      >
                        {item.title}
                      </div>


                      {item.value && (

                        <p
                          style={{
                            margin: 0,

                            fontSize:
                              mobile
                                ? 11
                                : 13,

                            lineHeight: 1.48,

                            color: '#746c65',

                            wordBreak: 'break-word'
                          }}
                        >
                          {item.value}
                        </p>

                      )}

                    </div>


                    {/* SETA */}

                    <div
                      style={{
                        width: 26,
                        height: 26,

                        display: 'flex',

                        alignItems: 'center',

                        justifyContent: 'center',

                        fontFamily: 'Arial, sans-serif',

                        fontSize: 22,

                        color: '#332a23',

                        transform:
                          aberto
                            ? 'rotate(90deg)'
                            : 'rotate(0deg)',

                        transition:
                          'transform 220ms ease'
                      }}
                    >
                      ›
                    </div>

                  </div>


                  {/* ===========================================
                      BANDEJA
                  =========================================== */}

                  <div
                    style={{
                      display: 'grid',

                      gridTemplateRows:
                        aberto
                          ? '1fr'
                          : '0fr',

                      transition:
                        'grid-template-rows 280ms ease'
                    }}
                  >

                    <div
                      style={{
                        overflow: 'hidden'
                      }}
                    >

                      <div
                        style={{
                          background: '#f7f3ee',

                          borderLeft:
                            '1px solid #e3dbd2',

                          borderRight:
                            '1px solid #e3dbd2',

                          borderBottom:
                            '1px solid #e3dbd2',

                          borderRadius:
                            '0 0 9px 9px',

                          padding:
                            aberto
                              ? mobile
                                ? '18px 15px 17px'
                                : '21px 26px 20px'
                              : '0 26px',

                          opacity:
                            aberto
                              ? 1
                              : 0,

                          transition:
                            'padding 280ms ease, opacity 180ms ease'
                        }}
                      >


                        {/* PEQUENO TÍTULO */}

                        <div
                          style={{
                            fontSize: 9,

                            letterSpacing: '0.22em',

                            textTransform: 'uppercase',

                            color: '#9a8d82',

                            marginBottom: 8
                          }}
                        >
                          POR QUE ESSA ESCOLHA FAZ DIFERENÇA
                        </div>


                        {/* NOME DO ITEM */}

                        <div
                          style={{
                            fontFamily:
                              'Georgia, Times New Roman, serif',

                            fontSize:
                              mobile
                                ? 18
                                : 20,

                            lineHeight: 1.25,

                            color: '#352b24',

                            marginBottom: 9
                          }}
                        >
                          {item.title}
                        </div>


                        {/* BENEFÍCIO */}

                        {infoExtra ? (

                          <p
                            style={{
                              margin: 0,

                              maxWidth: 720,

                              fontSize:
                                mobile
                                  ? 12
                                  : 13,

                              lineHeight: 1.65,

                              color: '#70665e'
                            }}
                          >
                            {infoExtra}
                          </p>

                        ) : (

                          <p
                            style={{
                              margin: 0,

                              maxWidth: 720,

                              fontSize:
                                mobile
                                  ? 12
                                  : 13,

                              lineHeight: 1.65,

                              color: '#9a9087'
                            }}
                          >
                            Informações adicionais deste item serão exibidas aqui.
                          </p>

                        )}


                        {/* RODAPÉ DA BANDEJA */}

                        <div
                          style={{
                            marginTop: 17,

                            paddingTop: 13,

                            borderTop:
                              '1px solid #e3dbd3',

                            display: 'flex',

                            alignItems: 'center',

                            justifyContent: 'space-between',

                            gap: 15
                          }}
                        >

                          <span
                            style={{
                              fontSize: 10,
                              color: '#9a8f85'
                            }}
                          >
                            Detalhes selecionados para este modelo
                          </span>


                          <button
                            type="button"

                            onClick={(e) => {
                              e.stopPropagation();
                              setDetalheAberto(null);
                            }}

                            style={{
                              border: 'none',

                              padding: 0,

                              background: 'transparent',

                              fontSize: 10,

                              color: '#60493b',

                              cursor: 'pointer',

                              whiteSpace: 'nowrap'
                            }}
                          >
                            Fechar ↑
                          </button>

                        </div>

                      </div>

                    </div>

                  </div>

                </div>

              );

            })}

          </div>

        </div>


        {/* ===================================================
            COLUNA DIREITA
        =================================================== */}

        <div
          style={{
            minWidth: 0,

            display: 'flex',

            flexDirection: 'column',

            gap: 14
          }}
        >


          {/* =================================================
              IMAGEM PRINCIPAL
          ================================================= */}

          <div
            style={{
              width: '100%',

              aspectRatio:
                mobile
                  ? '4 / 3'
                  : '1.55 / 1',

              borderRadius: 11,

              overflow: 'hidden',

              background: '#f3f0ec',

              border: '1px solid #e8e2dc',

              boxSizing: 'border-box'
            }}
          >

            {imagemPrincipal && (

              <img
                src={imagemPrincipal}

                alt={
                  nomeProduto ||
                  'Produto'
                }

                style={{
                  display: 'block',
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  objectPosition: 'center',
                  transform: 'scale(1.12)',
                  transformOrigin: 'center'
                }}
              />

            )}

          </div>


          {/* =================================================
              DIMENSÕES
          ================================================= */}

          <div
            style={{
              width: '100%',

              background: '#fff',

              border: '1px solid #e6e0d9',

              borderRadius: 10,

              padding:
                mobile
                  ? 15
                  : '18px 20px',

              boxSizing: 'border-box'
            }}
          >

            <div
              style={{
                display: 'flex',

                alignItems: 'center',

                justifyContent: 'space-between',

                gap: 15,

                marginBottom: 15
              }}
            >

              <div
                style={{
                  fontSize:
                    mobile
                      ? 10
                      : 11,

                  letterSpacing: '0.26em',

                  fontWeight: 500,

                  color: '#342b24'
                }}
              >
                DIMENSÕES
              </div>


              <div
                style={{
                  padding: '7px 12px',

                  borderRadius: 999,

                  background: '#f4f1ed',

                  fontSize: 10,

                  color: '#847a71',

                  whiteSpace: 'nowrap'
                }}
              >
                Medidas em centímetros
              </div>

            </div>


            {imagemDimensoes ? (

              <div
                style={{
                  width: '100%',

                  aspectRatio:
                    mobile
                      ? '1.4 / 1'
                      : '1.75 / 1',

                  overflow: 'hidden',

                  background: '#fbfaf8'
                }}
              >

                <img
                  src={imagemDimensoes}

                  alt="Dimensões do produto"

                  style={{
                    display: 'block',
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center',
                    transform: 'scale(1.10)',
                    transformOrigin: 'center'
                  }}
                />

              </div>

            ) : (

              <div
                style={{
                  width: '100%',

                  minHeight:
                    mobile
                      ? 180
                      : 245,

                  border:
                    '1px dashed #ddd6cf',

                  borderRadius: 7,

                  boxSizing: 'border-box',

                  display: 'flex',

                  alignItems: 'center',

                  justifyContent: 'center',

                  background: '#fbfaf8',

                  padding: 20
                }}
              >

                {medidas.length > 0 ? (

                  <div
                    style={{
                      width: '100%',

                      display: 'grid',

                      gridTemplateColumns:
                        'repeat(2, minmax(0,1fr))',

                      gap: 10
                    }}
                  >

                    {medidas.map((item) => (

                      <div
                        key={item.label}

                        style={{
                          padding: '12px',

                          border:
                            '1px solid #e7e1da',

                          borderRadius: 7,

                          background: '#fff'
                        }}
                      >

                        <div
                          style={{
                            fontSize: 9,

                            color: '#91877e',

                            textTransform: 'uppercase',

                            letterSpacing: '0.12em',

                            marginBottom: 5
                          }}
                        >
                          {item.label}
                        </div>


                        <div
                          style={{
                            fontSize: 13,

                            color: '#3f352d'
                          }}
                        >
                          {item.value}
                        </div>

                      </div>

                    ))}

                  </div>

                ) : (

                  <div
                    style={{
                      color: '#aaa097',

                      fontSize: 11,

                      textAlign: 'center'
                    }}
                  >
                    Imagem técnica das dimensões
                  </div>

                )}

              </div>

            )}

          </div>


          {/* =================================================
              MÓDULOS
          ================================================= */}

          {modulosUnicos.length > 0 && (

            <div
              style={{
                width: '100%',

                background: '#fff',

                border:
                  '1px solid #e6e0d9',

                borderRadius: 10,

                padding:
                  mobile
                    ? 15
                    : '18px 20px',

                boxSizing: 'border-box'
              }}
            >

              <div
                style={{
                  fontSize:
                    mobile
                      ? 10
                      : 11,

                  letterSpacing: '0.26em',

                  fontWeight: 500,

                  color: '#342b24',

                  marginBottom: 15
                }}
              >
                MÓDULOS DISPONÍVEIS
              </div>


              <div
                style={{
                  display: 'grid',

                  gridTemplateColumns:
                    mobile
                      ? 'repeat(2, minmax(0,1fr))'
                      : 'repeat(4, minmax(0,1fr))',

                  gap: 9
                }}
              >

                {modulosUnicos.map((valor, index) => (

                  <div
                    key={`${valor}-${index}`}

                    style={{
                      minHeight: 46,

                      display: 'flex',

                      alignItems: 'center',

                      justifyContent: 'center',

                      padding: '8px 10px',

                      border:
                        '1px solid #dfd8d0',

                      borderRadius: 7,

                      background: '#fff',

                      color: '#443930',

                      fontSize: 12,

                      boxSizing: 'border-box',

                      textAlign: 'center'
                    }}
                  >
                    {formatModulo(valor)}
                  </div>

                ))}

              </div>

            </div>

          )}

        </div>

      </div>


      {/* =====================================================
          CTA INFERIOR
      ===================================================== */}

      <div
        style={{
          width: '100%',

          marginTop:
            mobile
              ? 22
              : 30,

          display: 'grid',

          gridTemplateColumns:
            mobile
              ? '1fr'
              : 'minmax(0,1fr) minmax(270px,330px)',

          gap:
            mobile
              ? 17
              : 28,

          alignItems: 'center',

          padding:
            mobile
              ? '20px 17px'
              : '20px 28px',

          boxSizing: 'border-box',

          borderRadius: 10,

          background:
            'linear-gradient(90deg,#f0ece7 0%,#f8f6f3 100%)'
        }}
      >

        <div
          style={{
            display: 'flex',

            alignItems: 'center',

            gap:
              mobile
                ? 13
                : 18,

            minWidth: 0
          }}
        >

          <div
            style={{
              width:
                mobile
                  ? 42
                  : 54,

              height:
                mobile
                  ? 42
                  : 54,

              display: 'flex',

              alignItems: 'center',

              justifyContent: 'center',

              flex: '0 0 auto',

              fontSize:
                mobile
                  ? 24
                  : 29,

              color: '#634a3b',

              border:
                '1px solid #cfc4ba',

              borderRadius: 8
            }}
          >
            ♡
          </div>


          <div
            style={{
              minWidth: 0
            }}
          >

            <div
              style={{
                fontFamily:
                  'Georgia, Times New Roman, serif',

                fontSize:
                  mobile
                    ? 19
                    : 23,

                lineHeight: 1.2,

                color: '#352b24'
              }}
            >
              Tenha um ambiente que combine com a sua história.
            </div>


            <div
              style={{
                marginTop: 5,

                fontSize:
                  mobile
                    ? 11
                    : 13,

                lineHeight: 1.45,

                color: '#80766e'
              }}
            >
              Solicite um orçamento e receba atendimento personalizado.
            </div>

          </div>

        </div>


        <button
          type="button"

          onClick={onOrcamento}

          style={{
            width: '100%',

            minHeight: 52,

            border:
              '1px solid #634a3b',

            borderRadius: 8,

            background: '#634a3b',

            color: '#fff',

            cursor: 'pointer',

            fontSize: 14,

            fontWeight: 400,

            display: 'flex',

            alignItems: 'center',

            justifyContent: 'center',

            gap: 10,

            boxShadow:
              '0 8px 20px rgba(75,55,43,0.12)'
          }}
        >

          <BsClipboardCheck
            style={{
              fontSize: 17
            }}
          />

          Solicitar orçamento

        </button>

      </div>

    </section>

  );

}